module.exports = __webpack_public_path__ + "media/images/cheriwhite-e54b655e58caabffa8cc18875d391e56.jpg";